import { render } from "./user-profile-input-lite.vue?vue&type=template&id=0638f65c&scoped=true"
import script from "./user-profile-input-lite.vue?vue&type=script&lang=js"
export * from "./user-profile-input-lite.vue?vue&type=script&lang=js"

import "./user-profile-input-lite.vue?vue&type=style&index=0&id=0638f65c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0638f65c"]])

export default __exports__